import { render } from "./SearchAuto.vue?vue&type=template&id=418a2d4c&scoped=true"
import script from "./SearchAuto.vue?vue&type=script&lang=js"
export * from "./SearchAuto.vue?vue&type=script&lang=js"

import "./SearchAuto.vue?vue&type=style&index=0&id=418a2d4c&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418a2d4c"]])

export default __exports__